import { defineMessages } from 'react-intl';

export default defineMessages({
  whatsIncluded: {
    id: 'BundleGiftAOVItem.whatsIncluded',
    defaultMessage: 'What’s Included:',
  },
  productThumbnail: {
    id: 'BundleGiftAOVItem.productThumbnail',
    defaultMessage: 'Product Thumbnail',
  },
  toggleProductCard: {
    id: 'BundleGiftAOVItem.toggleProductCard',
    defaultMessage: 'Toggle product card',
  },
  detailsToggle: {
    id: 'BundleGiftAOVItem.detailsToggle',
    defaultMessage: 'Toggle',
  },
});
